import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { getAllBrands } from '../../services/data/brands';
import PageLoader from '../../componenets/PageLoader';
import { toast } from 'react-toastify';
import '../../style/style.css';
import "bootstrap/dist/css/bootstrap.min.css";

const SpinAndWin = () => {
  const groups = Array.from({ length: 12 }, (_, i) => `Group ${i + 1}`);
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchUsers = async () => {
    setLoading(true)      
    await getAllBrands().then((response)=>{    
      // console.log(response)      
      if (response.status === 200 || response.data.status === 'success'){        
        if(response.data.data.length > 0){
          setData(response.data.data)
        }else{
          setData([])
        }               
      }else{
        toast.error(response.data.message)       
      }           
    })      
    .catch((err)=>{
      toast.error("Error fetching");     
    })
    .finally(()=>{
      setLoading(false)
    })              
  }
  
  useEffect(() => {    
    fetchUsers()
  }, []);

  return (
     <section className='content'>
      {
        loading ? <PageLoader loading="Loading..."/> : (
          <div className="container d-flex flex-column align-items-center w-100 max-w-xl mx-auto p-4 gap-4 mt-5">      
            {/* Title Button */}
            <button 
              className="btn btn-light rounded-pill px-4 py-2 fw-medium spin-heading"
              // style={{backgroundColor:'#f0f5f5'}}
            >      
              Spin & Win
            </button>

            {/* Groups Grid */}
            <div className="row g-3 text-center">
              {data.length > 0 && data.map((group, index) => (
                <div key={index} className="col-12 col-md-3 align-items-center">
                  <Link to={`/wheel/${group?.name.replaceAll('/', '_')}`}
                    className="btn px-3 py-2 text-sm fw-medium" 
                    style={{
                      backgroundColor: index % 2 == 0 ? '#dcedc8' : '#e3f2fd', 
                      borderRadius:"12px",
                      height:"80px",
                      width:"300px"  

                    }}
                  >
                    { group?.name }                    
                  </Link>
                </div>
              ))}
            </div>

          </div>
        )
      }      
     </section>     
  );
};

export default SpinAndWin;
